// extracted by mini-css-extract-plugin
export var container = "styles-module--container--a8f91";
export var item_list = "styles-module--item_list--72b25";